<div class="dialog-title" >
  <p>{{ data.title || 'Additional Information' }}</p>
  <button mat-icon-button matDialogClose>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div matDialogContent [innerHTML]="data.infoText | sanitize"></div>
